import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import DecisionSummaryContainer from '../../../../document/edit/decision/summary/components/DecisionSummaryContainer';
import ApprovalLevelsContainer from '../../../../document/edit/decision/approvalLevels/components/ApprovalLevelsContainer';
import FolderWarrantiesContainer from 'features/document/edit/decision/warranties/components/FolderWarrantiesContainer';
import FolderCommentsCardContainer from 'features/folder/edit/comments/components/FolderCommentsCardContainer';
import FinancedOffersContainer from '../../generalData/financedOffers/components/FinancedOffersContainer';
import FacilityKpiIndicatorsContainer from '../../../../facility/edit/kpiIndicators/kpiIndicators/components/FacilityKpiIndicatorsContainer';
import OfferDecisionFinancedAssetsChartContainer from 'components/offer/edit/decision/OfferDecisionFinancedAssetsChartContainer';
import FolderExternalChecksContainer from './ExternalChecks/Container';
import ReorderComponentsContainer from '../../../../../components/common/reorderContainer/ReorderComponentsContainer';
import { ApplicationFeaturesContext } from 'providers/ApplicationFeaturesContext';

const defaultComponentsOrder = {
  DecisionSummary: 10,
  FacilityKpiIndicators: 20,
  ApprovalLevels: 30,
  FolderWarranties: 40,
  OfferDecisionFinancedAssetsChart: 50,
  FinancedOffers: 60,
  RiskComments: 70,
  FolderExternalChecks: 80
};

const FolderDecisionContainer = ({ documentId, siteId, isFacilityApproval, facilityId, facilitySiteId, offerId, offerSiteId, rights }) => {
  const { folderWithFinancedChart, offerWithWarranties } = useContext(ApplicationFeaturesContext);

  const getComponent = componentName => {
    switch (componentName) {
      case 'DecisionSummary':
        return rights.decisionSummaryRead && <DecisionSummaryContainer documentId={documentId} siteId={siteId} />;
      case 'FacilityKpiIndicators':
        return (
          isFacilityApproval && (
            <FacilityKpiIndicatorsContainer documentId={facilityId} siteId={facilitySiteId} isFromFolder={true} hasFacilityOffer={true} />
          )
        );
      case 'ApprovalLevels':
        return rights.decisionApprovalLevelRead && <ApprovalLevelsContainer documentId={documentId} siteId={siteId} />;
      case 'FolderWarranties':
        return (
          offerWithWarranties && rights.documentWarrantiesRead && <FolderWarrantiesContainer documentId={documentId} siteId={siteId} />
        );
      case 'OfferDecisionFinancedAssetsChart':
        return (
          !isFacilityApproval &&
          folderWithFinancedChart && (
            <OfferDecisionFinancedAssetsChartContainer
              documentId={offerId}
              siteId={offerSiteId}
              folderId={documentId}
              folderSiteId={siteId}
            />
          )
        );
      case 'FinancedOffers':
        return <FinancedOffersContainer documentId={documentId} siteId={siteId} />;
      case 'RiskComments':
        return <FolderCommentsCardContainer documentId={documentId} siteId={siteId} />;
      case 'FolderExternalChecks':
        return rights.decisionExternalChecksRead && <FolderExternalChecksContainer documentId={documentId} siteId={siteId} />;
      default:
        return null;
    }
  };

  return (
    <>
      <ReorderComponentsContainer
        reorderComponentsName={'folder_decision'}
        defaultComponentsOrder={defaultComponentsOrder}
        getComponent={getComponent}
      />
    </>
  );
};

FolderDecisionContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  facilityId: PropTypes.number,
  facilitySiteId: PropTypes.number,
  isFacilityApproval: PropTypes.bool,
  offerId: PropTypes.number,
  offerSiteId: PropTypes.number,
  rights: PropTypes.object.isRequired
};

export default FolderDecisionContainer;
